import React from 'react'
import styles from './style.module.scss'
import ImageIcon from '../ImageIcon'

const  Navbar : React.FC = () => {
    return(
        <div className={styles.Navbar}>
            <span>
                <ImageIcon imgUrl="/images/logo.png" backgroundColor="#ffca3a"/>
            </span>
            <span className={styles.NavbarItem}>
                <ImageIcon route ="/" imgUrl="/images/contact.png"/>
                <ImageIcon route ="/experiences" imgUrl="/images/team.png"/>
                <ImageIcon route ="/skills" imgUrl="/images/skills.png"/>
                <ImageIcon route ="/projects" imgUrl="/images/innovation.png"/>
            </span>
            
        </div>
    )
}

export default Navbar